import React from "react";
import { Modal } from "antd";
import styles from "./CommonModal.css"; // Assuming a CSS module for styling

const CommonModal = ({
    width = "96%",
    modalStyle = {},
    visible,
    onClose,
    title,
    children,
}) => {
    return (
        <Modal
            open={visible}
            onCancel={onClose}
            width={width} // Keep the original width for now, can be made configurable later
            footer={null}
            title={null} // We will render a custom title
            closeIcon={null} // We will render a custom close icon
            className={styles.commonModal} // Apply a class for overall modal styling
            destroyOnHidden={true}
            style={modalStyle}
        >
            <div className={styles.header}>
                <div className={styles.headerLeft}>
                    <span className={styles.headerTitle}>{title}</span>
                </div>
                <div
                    onClick={onClose}
                    style={{ cursor: "pointer" }}
                    className={styles.closeButton}
                >
                    {/* You might want to use an Ant Design Icon here, e.g., <CloseOutlined /> */}
                    <img
                        style={{ width: 14, height: 14 }}
                        src={require("@/assets/close2.png")}
                    />
                </div>
            </div>
            <div className={styles.content}>{children}</div>
        </Modal>
    );
};

export default CommonModal;
